import React from 'react';
import { withStyles } from '@mui/styles';
import classnames from 'classnames';

import {Card, CardHeader, CardContent, Box} from '@mui/material';

const style = {
    card: {
        flex: 'none',
        width: '100%',
        maxWidth: '100%',
        backgroundColor: 'var(--surface)',
        border: '1px solid var(--line)',
        borderRadius: 8,
        boxShadow: 'var(--sh)',
        overflow: 'hidden',
    },
    cardFill: {
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    cardHeader: {
        flex: 'none',
    },
    cardContent: {
        overflow: 'auto',
        position: 'relative',
        padding: '0px !important',
    },
    cardContentFill: {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden !important',
        display: 'flex',
        flexDirection: 'column',
    }
};

const CardElement = ({classes, action, content, title, width, height, style, titleTypographyProps, subheader, fill }) => {
    const titleNode = (title || subheader)
        ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0, flexWrap: 'nowrap' }}>
                {title && (
                    <Box component="span" sx={{ fontSize: 13.5, fontWeight: 600, color: 'var(--ink)', lineHeight: 1.3, flex: 'none' }}>
                        {title}
                    </Box>
                )}
                {subheader && (
                    <Box sx={{ flex: 'none', display: 'inline-flex', alignItems: 'center', minWidth: 0 }}>
                        {subheader}
                    </Box>
                )}
            </Box>
        )
        : title;

    return ( 
            <Card
                style={{width: `${width ? width : '100'}%`,  ...style}}
                className={classnames(classes.card, fill && classes.cardFill)}
                elevation={0}
            >
                {(title||action||subheader)&&
                    <CardHeader
                        className={classes.cardHeader}
                        action={action}
                        title={titleNode}
                        titleTypographyProps={{ component: 'div', ...titleTypographyProps }}
                    />
                }
                <CardContent
                    className={classnames(classes.cardContent, fill && classes.cardContentFill)}
                    style={{paddingTop: 0, paddingBottom: 0, height: fill ? undefined : (height ? `${height}` : 'auto')}}
                >
                    {content}
                </CardContent>
            </Card>
    )
}

export default withStyles(style)(CardElement);
